var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "6px",
    viewBox: "0 0 8 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9F4A8E76-C463-467F-8A73-5800ADEA733A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Login/Singup/RAD",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login---Password",
    transform: "translate(-1081.000000, -491.000000)",
    fill: "#78AA00"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1075.000000, 301.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.82098071,195.911332 L6.09494416,193.416164 C5.96835195,193.300654 5.96835195,193.100314 6.09494416,192.984804 L7.01467867,192.145586 C7.14127088,192.030076 7.36083241,192.030076 7.48742462,192.145586 L9.00653113,193.539559 L12.4667182,190.097441 C12.5933104,189.974108 12.8042974,189.966592 12.9394641,190.0821 L13.8932098,190.882815 C14.0283766,190.998325 14.0366135,191.190841 13.910023,191.314175 L9.31050603,195.903614 C9.17533931,196.026948 8.95611536,196.034464 8.82094864,195.911435 L8.82098071,195.911332 Z",
    id: "Fill-1-Copy"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.c9af265e885150a8ac4dbebe2d164de9.svg";
export { ForwardRef as ReactComponent };